import { Segment } from '@shared/interfaces/segment';
import { Observable } from 'rxjs';

export const SEGMENT_REPOSITORY = 'SegmentsRepository';

export interface SegmentsRepository {
  getItems(): Observable<any>;

  add(segment: Segment): Observable<any>;

  edit(segment: Segment): Observable<any>;

  delete(item: any): Observable<any>;
}
